var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23493 9.0527L4.12143 11.1662C3.74761 11.5398 3.24071 11.7497 2.71218 11.7497C2.18365 11.7497 1.67675 11.5398 1.30293 11.1662L0.83343 10.6967C0.459861 10.323 0.25 9.81632 0.25 9.28795C0.25 8.75959 0.459861 8.25286 0.83343 7.8792L3.88643 4.8257C4.26025 4.45207 4.76715 4.24219 5.29568 4.24219C5.82421 4.24219 6.33111 4.45207 6.70493 4.8257L7.17443 5.2957",
    stroke: "#181B5E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76372 2.94693L7.87722 0.83393C8.06225 0.648807 8.28195 0.501955 8.52375 0.401762C8.76555 0.301569 9.02473 0.25 9.28647 0.25C9.54821 0.25 9.80738 0.301569 10.0492 0.401762C10.291 0.501955 10.5107 0.648807 10.6957 0.83393L11.1652 1.30293C11.5388 1.67658 11.7486 2.18331 11.7486 2.71168C11.7486 3.24005 11.5388 3.74678 11.1652 4.12043L8.11222 7.17393C7.92719 7.35905 7.70749 7.50591 7.46569 7.6061C7.22388 7.70629 6.96471 7.75786 6.70297 7.75786C6.44123 7.75786 6.18205 7.70629 5.94025 7.6061C5.69845 7.50591 5.47875 7.35905 5.29372 7.17393L4.82422 6.70393",
    stroke: "#181B5E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6a48f6b883382a248a8a8ede1e91de0c.svg";
export { ForwardRef as ReactComponent };